import {
  Component,
  HostListener,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { InitEmbeddedApp, ResizeEvent } from '../../core/store/core.actions';
import { UserFlowStore } from '../../core/store/user-flow.store';
import { IntercomStore } from '../../core/store/intercom.store';
import { SdEmbedMessagingService } from '../../core/services/sd-embed-messaging.service';

@Component({
  selector: 'app-es01-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <router-outlet /> `,
  styles: [],
  standalone: false,
})
export class Es01AppComponent implements OnInit {
  private readonly store = inject<Store<AppState>>(Store);

  private readonly userFlowStore = inject(UserFlowStore);
  private readonly intercomStore = inject(IntercomStore);
  private readonly embedMessaging = inject(SdEmbedMessagingService);

  constructor() {
    this.store.dispatch(
      new ResizeEvent({ width: window.innerWidth, height: window.innerHeight })
    );
    this.store.dispatch(new InitEmbeddedApp());
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.store.dispatch(
      new ResizeEvent({
        width: event.target.innerWidth,
        height: event.target.innerHeight,
      })
    );
  }

  ngOnInit(): void {
    this.userFlowStore.initUserFlow();
  }
}
